import { Box, Stack, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import useCustomerBody from "./utils/useCustomerBody";
import TableComp from "src/components/shared/table/TableComp";
import useCustomerAction from "./utils/useCustomerAction";
import EmployeeFilter from "./components/EmployeeFilter";
import { USER_ROLE_TYPE } from "src/constant";
import useResetParamsOnTabChange from "src/hooks/useResetParamsOnTabChange";
import useAuthGlobal from "src/context/useAuthGlobal";
import useQueryParams from "src/hooks/useQueryParams";

const userSelectList = [
  {
    id: 1,
    title: "Staff",
    value: "staff",
  },
  {
    id: 2,
    title: "Sales",
    value: "sales",
  },
];

export default function EmployeeTable({ headerWarehouseId, userWarehouseId }) {
  const { userMe } = useAuthGlobal();
  const [option] = useQueryParams();
  const [keyword, setKeyword] = useState();
  const [searchBy] = useState();
  const [paramsQuery, setParamsQuery] = useState({
    role: undefined,
  });
  const [whouseIds, setWhouseIds] = useState({});

  useResetParamsOnTabChange(option?.tab, setParamsQuery, { role: undefined });

  useEffect(() => {
    const role = userMe?.role?.code;
    if (role !== USER_ROLE_TYPE.SUPER_ADMIN) {
      setWhouseIds({
        headerWarehouseId: headerWarehouseId,
        userWarehouseId: userWarehouseId,
      });
    }
  }, [userMe?.role?.code, headerWarehouseId, userWarehouseId, userMe]);

  const { header, sortData, bodyList, isLoading, error, pagi, setPagi, total } = useCustomerBody({
    userSelectList,
    keyword,
    searchBy,
    paramsQuery,
    ...whouseIds,
  });

  const action = useCustomerAction();

  return (
    <Fragment>
      <Stack
        gap={1.5}
        direction="row"
        justifyContent="space-between"
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={1.5}
          flex={1}
        >
          <Box
            display="flex"
            gap="6px"
            alignItems="flex-start"
            maxWidth="450px"
            width="100%"
          >
            <SearchFilterComp
              placeholder="Tìm kiếm thông tin nhân viên..."
              // selectList={userSelectList}
              getSearchKeyword={setKeyword}
              // getSelectKeyword={setSearchBy}
            />
          </Box>
          <Typography
            display="inline"
            sx={{ fontWeight: "bold", mb: 1.5 }}
          >
            {total < 10 ? "0" + total : total} nhân viên{" "}
          </Typography>
        </Box>
        {option?.tab !== "Sales" && (
          <EmployeeFilter
            setParamsQuery={setParamsQuery}
            paramsQuery={paramsQuery}
          />
        )}
      </Stack>

      <TableComp
        dynamicWidth={"800px"}
        sortData={sortData}
        headers={header}
        bodyList={bodyList ?? []}
        isLoading={isLoading}
        action={action}
        error={error}
        total={total}
        pagi={pagi}
        setPagi={setPagi}
      />
    </Fragment>
  );
}
